import moment from 'moment';
import _ from 'lodash';

class SummaryDataController {
  constructor($scope, $rootScope, AuthenticationService, TimesheetService, $http) {
    "ngInject";

    this.timesheetService = TimesheetService;

    this.timesheetStatusMap = {
      'REJECTED': 'Rejected',
      'SUBMITTED': 'Submitted',
      'APPROVED': 'Approved',
      'REJECTION_REQUESTED': 'Rejection Requested',
      'OPEN': 'Open'
    }

  }



}

export default SummaryDataController;



// WEBPACK FOOTER //
// ./client/pages/timesheet/components/summary-data/summary-data.controller.js